import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import _ from 'lodash';
import { AUTH_INDICATOR } from 'src/app/global/enums/auth-indicator.enum';
import { Ejecutivo } from 'src/app/global/interfaces/ejecutivo';
import { MarketplaceParameter } from 'src/app/global/interfaces/marketplace-parameter';
import { Paso1Login } from 'src/app/global/interfaces/paso-1-login';
import { GoogleTagManager } from 'src/app/global/providers/services/tag-manager/models/tag-manager.models';
import { InputErrorService } from 'src/app/global/services/input-errors.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { SessionService } from 'src/app/global/services/session.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { step1Messages } from 'src/app/messages/step-1-messages';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { AuthVMService } from 'src/app/view-model/services/auth-vm.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { environment } from '../../../../../../environments/environment';

const env = environment;

@Component({
  selector: 'app-persona-natural-login',
  templateUrl: './persona-natural-login.component.html',
  styleUrls: ['persona-natural-login.component.scss']
})
export class PersonaNaturalLoginComponent implements OnInit {
  validacionCheck = false;
  loading = false;
  processing = false;
  product: Product;
  isPersonaNatural = true;
  // count the clicks
  private clickTimeout = null;
  isMobile = null;
  public mensajeErrorDatosPersonales = step1Messages;
  utm?="";
  ejecutivo: Ejecutivo;

  @Output() nextStep: EventEmitter<any> = new EventEmitter();

  dataPersonaNatural: FormGroup = null;
  constructor(
    private authVmService: AuthVMService,
    private storage: LocalStorageService,
    private carroService: CarroComprasService,
    private tagM: TagManagerService,
    private dialogService: DialogService,
    private marketplaceRedirectService: MarketplaceRedirectService,
    private inputErrorService: InputErrorService,
    private carroServ: CarroComprasService,
    private route: ActivatedRoute,
    private sessionService: SessionService
  ) { }

  public messageRescatarDataError = {
    txtRut: [
      { type: 'required', message: step1Messages.REQUIRED_RUT_MESSAGE },
      { type: 'dniInvalid', message: step1Messages.INVALID_RUT_MESSAGE }
    ],
    txtEmail: [
      { type: 'required', message: step1Messages.REQUIRED_EMAIL_MESSAGE },
      { type: 'emailInvalid', message: step1Messages.REQUIRED_EMAIL_MESSAGE }
    ]
  };

  async ngOnInit(): Promise<void> {
    this.authVmService.initCaptcha();
    this.dataPersonaNatural = this.authVmService.createLoginForm();
    this.getSelectedProduct();
    this.getEjecutivoData();
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    this.utm = this.route.snapshot.queryParams.utm;
  }

  getSelectedProduct() {
    const parameters:MarketplaceParameter = this.carroServ.loadFromUrl();
    if (parameters) {
      parameters.productos.every((prod) => {
        this.dataPersonaNatural.patchValue({
          txtProducto: prod.codigoProducto
        });
      });
    }
  }

  getEjecutivoData() {
    this.ejecutivo = this.sessionService.ejecutivo != null ? this.sessionService.ejecutivo : this.sessionService.getEjecutivo();
    if(this.ejecutivo){
      if(this.sessionService.ejecutivo != null){
        this.dataPersonaNatural.patchValue({
          txtEjecutivo: this.sessionService.ejecutivo.id
        });
      }
    }
  }

  get rutControl(): FormControl {
    return this.dataPersonaNatural.get('txtRut') as FormControl;
  }

  get correoControl(): FormControl {
    return this.dataPersonaNatural.get('txtCorreo') as FormControl;
  }

  get telefonoControl(): FormControl {
    return this.dataPersonaNatural.get('txtTelefono') as FormControl;
  }

  get productoControl(): FormControl {
    return this.dataPersonaNatural.get('txtProducto') as FormControl;
  }

  get ejecutivoControl(): FormControl {
    return this.dataPersonaNatural.get('txtEjecutivo') as FormControl;
  }

  async onSubmit(): Promise<void> {
    let authResponse = null;
    let respuesta: any;
    try {
      this.loading = true;
      authResponse = await this.authVmService.authPersonaNatural(this.dataPersonaNatural, this.isMobile);
      console.warn(_.get(authResponse, 'indicador', ''));
      if (_.get(authResponse, 'indicador', '') === 'OK') {
          this.processing = false;
          this.save(authResponse);
          this.tagM.logDL_completa_datos();
          this.tagM.logEvent( GoogleTagManager.eventInteracciones().categriaComoVender('persona').accionClick().etiquetaAcontinuar());
      }
    } catch (exception) {
      this.tagM.logError('Paso 1', _.get(exception, 'error.mensaje.titulo', ''), _.get(exception, 'error.message', ''));
      console.log("Excepcion Encontrada:", _.get(exception, 'error.message', ''));
      if (_.includes(_.get(exception, 'error.mensaje.contenido'), 'se le han agotado los intentos')) {
        respuesta = this.dialogService.openAccountBloquedDialog();
      } else {
        console.error(exception);
        respuesta = this.dialogService.openErrorDialog('Lo sentimos', 'Estamos presentando problemas, no podemos cargar la página.<br>Por favor, intenta más tarde.');
      }
      respuesta.afterClosed().subscribe((resp) => {
        if (resp.action === 'OK') {
          return;
        }
      });

    } finally {
      this.loading = false;
      this.processing = false;
    }
  }

  Continuar($event: any) {
    $event.stopPropagation(); // Para que no se propague a los componentes inferiores

    if (!(this.processing)) {
      this.processing = true;
      this.clickTimeout = setTimeout(() => {
        this.onSubmit();
      }, 100);
    }

  }

  save(serviceResponse?: any) {
    const paso_1: Paso1Login = {
      run: this.rutControl.value,
      telefono: this.telefonoControl.value,
      correo: this.correoControl.value,
      producto: this.productoControl.value,
      ejecutivo: this.ejecutivoControl.value,
      retoma: serviceResponse != null ? _.get(serviceResponse, 'mensaje.contenido', '') : AUTH_INDICATOR.EMPTY_STRING,
      currentIsPersonaNatural: this.isPersonaNatural,
      utm: this.utm
    };

    this.storage.setPaso1Login(paso_1);
    this.storage.setCurrentPage(_.get(env, 'localStorage.PASO_2', ''));
    this.carroService.changePaso('P_1');

  }

  checkInput(campo: string) {
    this.inputErrorService.validarError('P1', this.dataPersonaNatural.get(campo));
  }

  onChangeForm($event) {
    console.debug($event, this.dataPersonaNatural.dirty);
  }
}
